// removed by extract-text-webpack-plugin
module.exports = {"home":"_19uTL1qv-1fq2PuVJbZCFf","masthead":"_3F5mfw7lxrfIE2-8FQkmms","wrapperTop":"KZAxz8b7_Ppvw_zfOSJvK","wrapperSearch":"_337_dKUB1qBLRNUQhCvyVD","title":"_3Bs0HpqtcfqySGGuu87pye","titleLogo":"i7H4Y9zRsFCApL63zNRWj","logo":"_3x-WdeSopZrTtpVkoRdXK","benefits":"_20sG2rPgHv7rZlDacsqcY7","carousel":"uKQ9JaO3nU3mfuL-rfUQH","blockTitle":"_3flBbc-oL5WSfJWeNrMeJv","darkBackground":"nDyQO3RThJ3DTAVwE6gWF","wrapperCountriesList":"_3ss2OJPMepLyZQb37VE08Y","professionalsTitle":"_1Ogu4EG1gsst6qaBDQz33b","subTitle":"_1Bc6BraP5CzfJ6fyrB4C9h"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ForeignPropertyPage/ForeignPropertypage.scss
// module id = 1604
// module chunks = 0